import { IDanhSachDangKyNganh2ActionTypes } from "../../action-types/quan-ly-nganh-2/IDanhSachDangKyNganh2Actions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachDangKyNganh2Reducer } from "../../reducer-model/quan-ly-nganh-2/IDanhSachDangKyNganh2Reducer";

export const iniState: IDanhSachDangKyNganh2Reducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachDangKyNganh2s: [],
};

export const danhSachDangKyNganh2Reducer = (state: IDanhSachDangKyNganh2Reducer = iniState, action: IDanhSachDangKyNganh2ActionTypes): IDanhSachDangKyNganh2Reducer => {
    switch (action.type) {
        case "DANH_SACH_DANG_KY_NGANH_2_LOAD_BY_DOT_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_DANG_KY_NGANH_2_LOAD_BY_DOT_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachDangKyNganh2s: action.payload,
            };
        case "DANH_SACH_DANG_KY_NGANH_2_LOAD_BY_DOT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachDangKyNganh2s: [],
            };
        case "DANH_SACH_DANG_KY_NGANH_2_DUYETS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "DANH_SACH_DANG_KY_NGANH_2_DUYETS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_DANG_KY_NGANH_2_DUYETS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}